"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_REQUIRED_TIER_2 = exports.MIGRATION_REQUIRED_TIER_1 = exports.MIGRATION_REQUIRED = exports.MIGRATION_FAILED = exports.MIGRATION_COMPLETED = void 0;
exports.MIGRATION_COMPLETED = 'MIGRATION_COMPLETED';
exports.MIGRATION_FAILED = 'MIGRATION_FAILED';
exports.MIGRATION_REQUIRED = 'MIGRATION_REQUIRED';
exports.MIGRATION_REQUIRED_TIER_1 = 'MIGRATION_REQUIRED_TIER_1';
exports.MIGRATION_REQUIRED_TIER_2 = 'MIGRATION_REQUIRED_TIER_2';
